export default __webpack_public_path__ + "static/GoodFaithEstimateImage-24770dadee2601dbbb3f4d3bb9a5e172.png";